import { createBooleanFeatureFlag, createFeatureFlagConfig, createRemoteFeatureFlag } from './featureFlags.factories';

export const FEATURE_FLAG_VALUES = {
  layout: createFeatureFlagConfig('layout', ['aloha', 'brannan']),
  guestsitetarget: createFeatureFlagConfig('guestsitetarget', ['bliss', 'charm']),
  nossr: createBooleanFeatureFlag('nossr'),
  joyWeb: createFeatureFlagConfig('joy-web', true),
  pseudoLocalization: createFeatureFlagConfig('pseudoloc', ['true', 'all']),
  bookmarkletPopup: createBooleanFeatureFlag('bookmarkletPopup'),
  enableSsr: createBooleanFeatureFlag('enablessr'),
  doRegistryOnboardingCardsReset: createBooleanFeatureFlag('doRegistryOnboardingCardsReset'),
  registryOnboardingSurvey: createFeatureFlagConfig('registryOnboardingSurvey', ['force', 'reset', 'force5']),
  registryOnboardingV3Experiment: createRemoteFeatureFlag({
    key: 'registryOnboardingV3Experiment',
    supportedValues: ['control', 'treatment'],
  }),
  enableRegistryTransfer: createBooleanFeatureFlag('enableRegistryTransfer', true),
  enableHaveYouPurchasedModal: createBooleanFeatureFlag('enableHaveYouPurchasedModal', true),
  enableHaveYouPurchasedModalExternalLinkClick: createBooleanFeatureFlag('enableHaveYouPurchasedModalExternalLinkClick', true),
  enableCashFundCheckoutV2: createBooleanFeatureFlag('enableCashFundCheckoutV2', true),
  enableLoadingStyleApplicator: createBooleanFeatureFlag('enableLoadingStyleApplicator'),
  enableAddressVerificationModal: createBooleanFeatureFlag('enableAddressVerificationModal'),
  enableAddEditGiftNote: createBooleanFeatureFlag('enableAddEditGiftNote', true),
  enableCurationHomeExpert: createBooleanFeatureFlag('enableCurationHomeExpert', true),
  enableBuyForMyselfFromPurchaseConfirmation: createBooleanFeatureFlag('enableBuyForMyselfFromPurchaseConfirmation', true),
  enableRandomLabelsGuestRegistryProducts: createBooleanFeatureFlag('enableRandomLabelsGuestRegistryProducts'),
  enableSplitPurchaseDialog: createBooleanFeatureFlag('enableSplitPurchaseDialog', true),
  enableShippingAddressWarning: createBooleanFeatureFlag('enableShippingAddressWarning', true),
  orderTrackingFeature: createBooleanFeatureFlag('orderTrackingFeature', true),
  enableMFASettings: createBooleanFeatureFlag('enableMFASettings', true),
  enableAffiliateCheckoutV2: createBooleanFeatureFlag('enableAffiliateCheckoutV2', true),
  enableNewExternalRegistry: createBooleanFeatureFlag('enableNewExternalRegistry'),
  enableChecklistInGiftBasketWidget: createBooleanFeatureFlag('enableChecklistInGiftBasketWidget', true),
  enableBlankDates: createBooleanFeatureFlag('enableBlankDates', true),
  enableCustomEventName: createBooleanFeatureFlag('enableCustomEventName', true),
  enableBabyRegistry: createBooleanFeatureFlag('enableBabyRegistry', true),
  enableExternalRegistriesForBabyReg: createBooleanFeatureFlag('enableExternalRegistriesForBabyReg', true),
  enableBabyRegistrySoftLaunchFeatures: createBooleanFeatureFlag('enableBabyRegistrySoftLaunchFeatures', true),
  seamlessCheckoutVariant: createRemoteFeatureFlag({ key: 'wgseamlesscheckout', supportedValues: ['variant1', 'variant2', 'variant3'] }),
  hideSyncInstead: createRemoteFeatureFlag({ key: 'hidesyncinstead' }),
  joyRefundsEnabled: createRemoteFeatureFlag({ key: 'joyrefundsenabled', supportedValues: ['on', 'off'] }),
  guestLinkUseRedirectService: createRemoteFeatureFlag({ key: 'guestlinkuseredirectservice', supportedValues: ['on', 'off'] }),
  enableInlineEditing: createBooleanFeatureFlag('enableInlineEditing', false),
  isMobileInlineEditMode: createBooleanFeatureFlag('isMobileInlineEditMode', false),
  supportAutocompletePreDefinedPlacesEnabled: createRemoteFeatureFlag({ key: 'supportAutocompletePreDefinedPlacesEnabled', supportedValues: ['on', 'off'] }),
  websiteBannerMapping: createRemoteFeatureFlag('websitebannermapping'),
  rsvpEnableAccommodationsRedirect: createRemoteFeatureFlag({ key: 'rsvpenableaccommodationsredirect', supportedValues: ['control', 'treatment'] }),
  enableRegistryRedirectInMessaging: createRemoteFeatureFlag('enableRegistryRedirectInMessaging'),
  messageDraftsEnabled: createRemoteFeatureFlag({ key: 'messagedraftsenabled', supportedValues: ['on', 'off'] }),
  newCashFundsEnabled: createRemoteFeatureFlag('newCashFundsEnabled'),
  websiteCashFundComponentEnabled: createRemoteFeatureFlag('websiteCashFundComponentEnabled'),
  websiteCashFundsi18nEnabled: createRemoteFeatureFlag('websiteCashFundsi18nEnabled'),
  weddingGeneralMessagingEnabled: createRemoteFeatureFlag('weddingGeneralMessagingEnabled'),
  rsvpDeadlineEnabled: createBooleanFeatureFlag('rsvpDeadlineEnabled'),

  /**
   * Is being AB tested
   */
  // this is a long-lived flag; the Feature is only shown to UK Couples, a filter powered entirely by Amplitude
  cambiumGroupRegistryReferralsEnabled: createRemoteFeatureFlag('cambiumGroupRegistryReferralsEnabled'),
  universalCatalogSearchEnabled: createRemoteFeatureFlag('universalCatalogSearchEnabled'),
  universalCatalogMeshExperiment: createRemoteFeatureFlag({
    key: 'universalCatalogMeshExperiment',
    supportedValues: ['control', 'low-volume-google-shopping-first', 'low-volume-joy-catalog-first', 'joy-catalog-first'],
  }),
  websiteWeatherReportEnabled: createRemoteFeatureFlag('websiteWeatherReportEnabled'),
  registryCompactDonationViewEnabled: createRemoteFeatureFlag({
    key: 'registryCompactDonationViewEnabled',
    supportedValues: ['on', 'off'],
    defaultValue: 'off',
  }),

  /* things to do experiments */
  websiteThingsToDoLayoutExperiment: createRemoteFeatureFlag({ key: 'websiteThingsToDoLayoutExperiment', supportedValues: ['clean', 'modal', 'links', 'off'] }),
  honeymoonPlanningExperiment: createRemoteFeatureFlag({ key: 'honeymoonPlanningExperiment', supportedValues: ['on', 'off'] }),
  enableAllyPromo: createRemoteFeatureFlag('enableAllyPromo'),
  /** Placement: create-fund dialog (`AllyBankModal`). Gated with `enableAllyPromo &&`. */
  enableAllyPromoCreateFundDialog: createRemoteFeatureFlag('enableAllyPromoCreateFundDialog'),
  /** Placement: registry admin gift tracker empty state (`AllyBanner`). Gated with `enableAllyPromo &&`. */
  enableAllyPromoGiftTracker: createRemoteFeatureFlag('enableAllyPromoGiftTracker'),
  /** Placement: transfer-to-bank dialog (`TransferToBankDialogView` / `AllyPromoBlock`). Gated with `enableAllyPromo &&`. */
  enableAllyPromoTransferToBank: createRemoteFeatureFlag('enableAllyPromoTransferToBank'),
  /**
   * Prevent using cached SSR html.
   */
  skipSsrCache: createBooleanFeatureFlag('skipssrcache'),
  logSsrUserAgent: createBooleanFeatureFlag('logSsrUserAgent'),

  exampleOnOffRemoteFeatureFlag: createRemoteFeatureFlag('exampleOnOffFeatureFlag'),
  exampleMultiVariantRemoteFeatureFlag: createRemoteFeatureFlag({ key: 'examplemultivariantfeatureflag', supportedValues: ['variant1', 'variant2'], defaultValue: 'variant1' }),
  exampleExperimentFeatureFlag: createRemoteFeatureFlag({ key: 'exampleexperimentfeatureflag', supportedValues: ['control', 'treatment'] }),
  exampleExperimentBucketedByJoyEvent: createRemoteFeatureFlag({ key: 'exampleexperimentbucketedbyjoyevent', supportedValues: ['control', 'treatment'] }),
  adminDashboardOverviewFAQs: createRemoteFeatureFlag({ key: 'adminDashboardOverviewFAQs', supportedValues: ['control', 'treatment'] }),
  adminDashboardOverviewHighlights: createRemoteFeatureFlag({ key: 'adminDashboardOverviewHighlights', supportedValues: ['control', 'variant1', 'variant2'] }),
  /*
   * Gift Wrap Remote Feature Flags
   */
  registryGiftWrapDefaultUSABillingAddress: createRemoteFeatureFlag('registrygiftwrapdefaultusabillingaddress'),
  registryGiftWrapEcardPrice: createRemoteFeatureFlag('registrygiftwrapecardprice'),
  registryGiftWrapExperimentEnabled: createRemoteFeatureFlag('registrygiftwrapexperimentenabled'),
  registryGiftWrapCashEnabled: createRemoteFeatureFlag('registrygiftwrapcashenabled'),
  registryGiftWrapAffiliateEnabled: createRemoteFeatureFlag('registrygiftwrapaffiliateenabled'),
  registryGiftWrapThemeDisplayCount: createRemoteFeatureFlag('registrygiftwrapthemedisplaycount'),
  registryGiftWrapThemeExpandIcon: createRemoteFeatureFlag({
    key: 'registrygiftwrapthemeexpandicon',
    supportedValues: ['plus', 'chevron'],
    defaultValue: 'plus',
  }),
  registryGiftWrapUseEnvelopeForRecipient: createRemoteFeatureFlag('registrygiftwrapuseenvelopeforrecipient'),
  rsvpCongratulationsEcardUserIsInUS: createRemoteFeatureFlag('rsvpCongratulationsEcardUserIsInUS'),
  rsvpCongratulationsEcardExperimentEnabled: createRemoteFeatureFlag('rsvpCongratulationsEcardExperimentEnabled'),
  rsvpCongratulationsECardPrice: createRemoteFeatureFlag('rsvpCongratulationsECardPrice'),
  rsvpCongratulationsEventHandleExcludeList: createRemoteFeatureFlag('rsvpcongratulationseventhandleexcludelist'),
  rsvpVersion: createRemoteFeatureFlag({ key: 'rsvpVersion', supportedValues: ['basic', 'offer'] }),
  rsvpGuestFlowAccommodationsStep: createRemoteFeatureFlag({ key: 'rsvpguestflowaccommodationsstep', supportedValues: ['control', 'treatment', 'off'] }),
  rsvpGuestFlowAccommodationsStepWithAccoms: createRemoteFeatureFlag({ key: 'rsvpguestflowaccommodationsstepwithaccoms', supportedValues: ['control', 'treatment'] }),
  enableRsvpReminderMessage: createRemoteFeatureFlag('enablersvpremindermessage'),
  rsvpButtonCustomLabel: createRemoteFeatureFlag('rsvpbuttoncustomlabel'),
  /*
   * Print Remote Feature Flags
   */
  premiumEcardMessagingV3HistoryEnabled: createRemoteFeatureFlag({ key: 'premiumecardmessagingv3historyenabled', supportedValues: ['on', 'off'] }),
  messagingCenterPollingRates: createRemoteFeatureFlag({ key: 'messagingcenterpollingrates', supportedValues: ['on', 'off'] }),
  enableIntercomChatPostRsvp: createRemoteFeatureFlag({ key: 'enableintercomchatpostrsvp', supportedValues: ['on', 'off'] }),
  askGuestForHotelRecommendationsEnabled: createRemoteFeatureFlag({ key: 'askguestforhotelrecommendationsenabled', supportedValues: ['on', 'off'] }),
  printCouponCodeLaunch: createRemoteFeatureFlag({ key: 'printcouponcodelaunch', supportedValues: ['on'] }),
  printCreateWeddingRedirect: createRemoteFeatureFlag({ key: 'printcreateweddingredirect', supportedValues: ['control', 'treatment'] }),
  printDesignConciergeCheckoutEnabled: createRemoteFeatureFlag('printdesignconciergecheckoutenabled'),
  printSuperAdminDiscountEnabled: createRemoteFeatureFlag('printsuperadmindiscountenabled'),
  printGalleryThemeDisplayOrder: createRemoteFeatureFlag({ key: 'printgallerythemedisplayorder', supportedValues: ['on', 'off'] }),
  printDigitalInternationalShipping: createRemoteFeatureFlag({ key: 'printdigitalinternationalshipping', supportedValues: ['restricted', 'off'] }),
  printInternationalShipping: createRemoteFeatureFlag({ key: 'printinternationalshipping', supportedValues: ['restricted', 'off'] }),
  printImagineOptions: createRemoteFeatureFlag('printimagineoptions'),
  printImagineHoliday: createRemoteFeatureFlag('printimagineholiday'),
  printImagineShowValueProps: createRemoteFeatureFlag('printimagineshowvalueprops'),
  printImagineStyles: createRemoteFeatureFlag('printimaginestyles'),
  printLocalCurrency: createRemoteFeatureFlag('printlocalcurrency'),
  printValuePropsData: createRemoteFeatureFlag({ key: 'printvaluepropsdata', supportedValues: ['on', 'group1', 'group2'] }),
  printSaleCodeV2: createRemoteFeatureFlag({ key: 'printsalecodev2', supportedValues: ['group1', 'group2', 'group3'] }),
  printGalleryVideoAutoPlay: createRemoteFeatureFlag('printgalleryvideoautoplay'),
  printCouponCodeLaunchV2: createRemoteFeatureFlag('printcouponcodelaunchv2'),
  printPremiumDigitalPricing: createRemoteFeatureFlag('printpremiumdigitalpricing'),
  printRegistryThankYouCrossSellExperiment: createRemoteFeatureFlag({ key: 'printregistrythankyoucrosssellexperiment', supportedValues: ['control', 'treatment'] }),
  printGalleryEnableSearch: createRemoteFeatureFlag('printgalleryenablesearch'),
  printSearch: createRemoteFeatureFlag('printsearch'),
  printDigitalSMSUpsellEnabled: createRemoteFeatureFlag({ key: 'printdigitalsmsupsellenabled', supportedValues: ['on', 'off'] }),
  printSalesAllowedCountryList: createRemoteFeatureFlag({ key: 'printsalesallowedcountrylist', supportedValues: ['on', 'off'] }),
  printStripeTaxCodeList: createRemoteFeatureFlag({ key: 'printstripetaxcodelist', supportedValues: ['on', 'off'] }),
  printGalleryCardTileCarouselContent: createRemoteFeatureFlag('printgallerycardtilecarouselcontent'),
  printPdpPreviewPaneAssetsData: createRemoteFeatureFlag('printpdppreviewpaneassetsdata'),
  printPdpEnableInteractivePrintPreview: createRemoteFeatureFlag('printpdpenableinteractiveprintpreview'),
  printPaperFoilConfig: createRemoteFeatureFlag('printpaperfoilconfig'),
  printOrderTrackingUpdatedLogic: createRemoteFeatureFlag('printordertrackingupdatedlogic'),
  printCollectPhoneNumberOnIntlShippingAddressEnabled: createRemoteFeatureFlag({ key: 'printcollectphonenumberonintlshippingaddressenabled', supportedValues: ['on', 'off'] }),
  accommodationsRemindMeLaterExperiment: createRemoteFeatureFlag({ key: 'accommodationsremindmelaterexperiment', supportedValues: ['control', 'treatment'] }),
  remindMeLaterInGuestGuide: createRemoteFeatureFlag({ key: 'remindmelateringuestguide', supportedValues: ['on', 'off'] }),
  stationeryBusySeasonsShippingWarningsEnabled: createRemoteFeatureFlag('stationerybusyseasonsshippingwarningsenabled'),
  /*
   * Website Designer Remote Feature Flags
   */
  websiteDesignerTemplatesGalleryFullWidthEnabled: createRemoteFeatureFlag({ key: 'websitedesignertemplatesgalleryfullwidthenabled', supportedValues: ['on', 'off'] }),
  websiteWelcomePageAsCustomPage: createRemoteFeatureFlag({ key: 'websitewelcomepageascustompage', supportedValues: ['on', 'off'] }),
  websiteDesignerTemplatesGalleryV2Enabled: createRemoteFeatureFlag({ key: 'websitedesignertemplatesgalleryv2enabled', supportedValues: ['on', 'off'] }),
  websiteDesignerFullWebsitePreviewEnabled: createRemoteFeatureFlag({ key: 'websitedesignerfullwebsitepreviewenabled', supportedValues: ['on', 'off'] }),
  websiteDesignerV3Enabled: createRemoteFeatureFlag({ key: 'websitedesignerv3enabled', supportedValues: ['on', 'off'] }),
  websiteHeaderAndNavEffectsEnabled: createRemoteFeatureFlag('websiteheaderandnaveffectsenabled'),
  websiteHeaderPhotoBackgroundAutoContrastEnabled: createRemoteFeatureFlag({ key: 'websiteheaderphotobackgroundautocontrastenabled', supportedValues: ['on', 'off'] }),
  websiteAllPagesAsCustomPagesEnabled: createRemoteFeatureFlag({ key: 'websiteallpagesascustompagesenabled', supportedValues: ['on', 'off', 'onjoysuperuser'] }),
  sunsetVideoPageEnabled: createRemoteFeatureFlag({ key: 'sunsetvideopageenabled', supportedValues: ['on', 'off'] }),
  websiteDesignerCustomArtEnabled: createRemoteFeatureFlag({ key: 'websitedesignercustomartenabled', supportedValues: ['on', 'off'] }),
  websiteDesignerTemplatePreviewEnabled: createRemoteFeatureFlag({ key: 'websitedesignertemplatepreview', supportedValues: ['on', 'off'] }),
  websiteTemplatesEnableAISearch: createRemoteFeatureFlag('websitetemplatesenableaisearch'),
  websiteGuestNavigationExperiment: createRemoteFeatureFlag({
    key: 'websiteguestnavigationexperiment',
    supportedValues: ['control', 'treatment'],
    defaultValue: 'control',
  }),
  websiteUseNewSaveMutation: createRemoteFeatureFlag('websiteusenewsavemutation'),
  websiteTemplatesEnableHoverAnimation: createRemoteFeatureFlag('websitetemplatesenablehoveranimation'),
  websiteTemplatesEnableDefaultPhotoFallback: createRemoteFeatureFlag({ key: 'websitetemplatesenabledefaultphotofallback', supportedValues: ['on', 'off'] }),
  websiteFullySsrGuestSite: createRemoteFeatureFlag('websitefullyssrguestsite'),
  websiteTemplatesEnableThumbnailCustomization: createRemoteFeatureFlag({ key: 'websitetemplatesenablethumbnailcustomization', supportedValues: ['on', 'off'] }),
  /**
   * Drives charm server -- fetches amplitude FF variants to be hydrated during SSR.
   */
  websiteCharmFullySsrGuestSite: createRemoteFeatureFlag('websitecharmfullyssrguestsite'),
  autoNavigateSingleComponentEnabled: createRemoteFeatureFlag({ key: 'autonavigatesinglecomponent', supportedValues: ['on', 'off'] }),

  /*
   * Registry Admin Remote Feature Flags
   */
  messagingEnableHotelBlockReminderNotification: createRemoteFeatureFlag('messagingenablehotelblockremindernotification'),
  messagingEnableHotelBlockReminderSMS: createRemoteFeatureFlag('messagingenablehotelblockremindersms'),
  messagingEmailDomainUnavailableNotification: createRemoteFeatureFlag('messagingemaildomainunavailablenotification'),
  registryCashFundCurrency18nEnabled: createRemoteFeatureFlag('registryCashFundCurrency18nEnabled'),
  registryDisableSyncRegistry: createRemoteFeatureFlag({ key: 'registryDisableSyncRegistry', supportedValues: ['control', 'treatment'] }),
  registrySyncIsDisabledDate: createRemoteFeatureFlag({ key: 'registrySyncIsDisabledDate' }),
  registryKycLaterEnabled: createRemoteFeatureFlag('registryKycLaterEnabled'),
  registryDashboardTitlesExperiment: createRemoteFeatureFlag({ key: 'registryDashboardTitlesExperiment', supportedValues: ['control', 'treatment'] }),
  registryOverviewVirtualConsultation: createRemoteFeatureFlag({ key: 'registryOverview-VirtualConsultation', supportedValues: ['control', 'treatment'] }),
  registryUniversalRecommendationsEnabled: createRemoteFeatureFlag({ key: 'registryUniversalRecommendationsEnabled' }),
  //old universal recommendation flag - buggy flag - we keep it here to rise an issue to amplitude
  syncAndTransferRegistryProductRecommendation: createRemoteFeatureFlag({
    key: 'syncAndTransferRegistryProductRecommendation',
    supportedValues: ['control', 'treatmentskipextrastepsintransfersync', 'treatmentfullrecommendationflow'],
  }),
  /*
   * Travel Remote Feature Flags
   */
  hotelBlockEnabled: createRemoteFeatureFlag('hotelblockenabled'),
  shortlistReleased: createRemoteFeatureFlag('shortlistreleased'),
  hotelBlockContactMethodMeeting: createRemoteFeatureFlag({ key: 'hotelBlockContactMethodMeeting', supportedValues: ['off', 'on'] }),
  hotelBlockContactMethodSms: createRemoteFeatureFlag({ key: 'hotelBlockContactMethodSms', supportedValues: ['off', 'on'] }),
  hotelBlockContactMethodEmail: createRemoteFeatureFlag({ key: 'hotelBlockContactMethodEmail', supportedValues: ['off', 'on'] }),
  newtimepickerEnabled: createRemoteFeatureFlag({ key: 'newtimepicker', supportedValues: ['on', 'off'] }),
  perkIntercomWorkflowTest: createRemoteFeatureFlag({ key: 'perkIntercomWorkflowTest', supportedValues: ['on', 'off'] }),
  roomBlockManagerDialogPerkPrintPromoCode: createRemoteFeatureFlag({ key: 'roomblockmanagerdialogperkprintpromocode', supportedValues: ['on', 'off'] }),
  roomBlockManagerDialogRegistryPromoCode: createRemoteFeatureFlag({ key: 'roomblockmanagerdialogregistrypromocode', supportedValues: ['on', 'off'] }),
  messagingPostRsvpHotelSearchUrl: createRemoteFeatureFlag({ key: 'messagingpostrsvphotelsearchurl', supportedValues: ['off', 'on'] }),
  postRSVPEnableNearbyHotelsCard: createRemoteFeatureFlag({ key: 'postrsvpenablenearbyhotelscard', supportedValues: ['control', 'treatment'] }),
  postRsvpBookingAutoReminder: createRemoteFeatureFlag({ key: 'postrsvpbookingautoreminder', supportedValues: ['on', 'off'] }),
  venueAddressLocationEnabled: createRemoteFeatureFlag({ key: 'venueAddressLocationEnabled', supportedValues: ['on', 'off'] }),
  hotelRedirectInterceptorEnabled: createRemoteFeatureFlag({ key: 'hotelRedirectInterceptorEnabled', supportedValues: ['on', 'off'] }),
  travelAccommodationConnectionEnabled: createRemoteFeatureFlag({ key: 'travelAccommodationConnectionEnabled', supportedValues: ['on', 'off'] }),
  travelAccommodationsConsoleV2: createRemoteFeatureFlag({ key: 'travelaccommodationsconsolev2', supportedValues: ['control', 'treatment'] }),
  localeBasedHotelCurrency: createRemoteFeatureFlag({ key: 'localeBasedHotelCurrency', supportedValues: ['on', 'off'] }),
  // Enables page currency setting in accommodations settings
  accommodationsPageCurrencyEnabled: createRemoteFeatureFlag({ key: 'accommodationsPageCurrencyEnabled', supportedValues: ['on', 'off'] }),
  // Enables check-in/check-out date settings in Where to Stay
  enableCheckInCheckOutDateInTravelSettings: createRemoteFeatureFlag({
    key: 'enableCheckInCheckOutDateInTravelSettings',
    supportedValues: ['control', 'treatment'],
  }),
  enableAccommodationsPriceComparisonV2: createRemoteFeatureFlag({ key: 'enableAccommodationsPriceComparisonV2', supportedValues: ['on', 'off'] }),
  accommodationsPriceComparisonExperiment: createRemoteFeatureFlag({ key: 'accommodationsPriceComparisonExperiment', supportedValues: ['link', 'price', 'no-comparison'] }),
  minimumPercentageOffToDisplay: createRemoteFeatureFlag({ key: 'minimumPercentageOffToDisplay', supportedValues: ['on', 'off'] }),
  accommodationPlaceUserNote: createRemoteFeatureFlag({ key: 'accommodationplaceusernote', supportedValues: ['on', 'off'] }),
  accommodationsDiscountTooltipEnabled: createRemoteFeatureFlag({ key: 'accommodationsDiscountTooltipEnabled', supportedValues: ['control', 'treatment'] }),
  /**
   * Mobile listings panel:
   * - control: current mobile layout
   * - treatment_clickable_card: new mobile layout with tap-anywhere card interaction
   * - treatment_cta_button: new mobile layout with CTA button interaction
   */
  accommodationsListingEntryMobileLayoutV2: createRemoteFeatureFlag({
    defaultValue: 'control',
    supportedValues: ['control', 'treatment_clickable_card', 'treatment_cta_button'],
    key: 'accommodationslistingentrymobilelayoutv2',
  }),
  accomodationsNewMobilePDPEnabled: createRemoteFeatureFlag('accommodationsnewmobilepdp'),
  accommodationsPlaceholdersCountOverride: createRemoteFeatureFlag('accommodationsplaceholderscountoverride'),
  hotelpdp3: createBooleanFeatureFlag('hotelpdp3', false),
  accommodationsCustomPageSlugKeywords: createRemoteFeatureFlag('accommodationsCustomPageSlugKeywords'),
  travelStripeExpressPayments: createRemoteFeatureFlag({ key: 'travelStripeExpressPayments', supportedValues: ['control', 'treatment'] }),
  accommodationLinkInterceptionEnabled: createRemoteFeatureFlag({ key: 'accommodationLinkInterceptionEnabled', supportedValues: ['control', 'treatment'] }),
  accommodationsTravelDistanceExperiment: createRemoteFeatureFlag({ key: 'accommodationsTravelDistanceExperiment', supportedValues: ['control', 'treatment'] }),
  // feature flag with payload of all hotel coupons, used for shared look-up between FE and travel_reservation_service
  travelHotelCoupons: createRemoteFeatureFlag({ key: 'travelHotelCoupons', supportedValues: ['on', 'off'] }),
  // experiment flag to control which cohort can experience hotel coupons
  travelHotelCouponsAccommodationItem: createRemoteFeatureFlag({ key: 'travelHotelCouponsAccommodationItem', supportedValues: ['treatment', 'control'] }),
  forceHotelDiscountAtLeastSomeSavings: createBooleanFeatureFlag('forceHotelDiscountAtLeastSomeSavings'),
  travelHotelPDPCreatesReservation: createRemoteFeatureFlag({ key: 'travelHotelPDPCreatesReservation', supportedValues: ['on', 'off'] }),
  /** Enables filtering cancellation policy offers above the allowed surcharge threshold. */
  travelHotelOfferSurchargeFilter: createRemoteFeatureFlag({ key: 'travelHotelOfferSurchargeFilter', supportedValues: ['control', 'treatment'] }),
  /** Hides non-refundable rates that are outpriced by a refundable rate for the same board basis. */
  hideExpensiveNonRefundableRates: createRemoteFeatureFlag({ key: 'hideExpensiveNonRefundableRates', supportedValues: ['control', 'treatment'] }),
  pdpCustomerReviews: createRemoteFeatureFlag({ key: 'pdpCustomerReviews', supportedValues: ['control', 'treatment'] }),
  /** For surfacing AI generated properties on auto-populated accommodations (whyThisHotelIsAGreatPick and proposedNoteFromHostToGuest) */
  travelAutoPopulatedAiNotesSurfaced: createRemoteFeatureFlag({ key: 'travelAutoPopulatedAiNotesSurfaced', supportedValues: ['on', 'off'] }),
  /**
   * Controls how hotel offers should be matched when merging cancellation policies.
   * See OfferMatchStrategy enum for available values and their descriptions.
   */
  travelHotelOfferMatchStrategy: createRemoteFeatureFlag({
    key: 'travelHotelOfferMatchStrategy',
    // Had to move this locally because of TSC complaints.
    supportedValues: ['control', 'offergroupid', 'unitname', 'groupidandunitname'],
  }),
  /** Enables reservation lookup by both UUID and order ID (non-UUID) using the travelOfferReservationByIdOrOrderId endpoint */
  travelReservationByOrderId: createRemoteFeatureFlag({ key: 'travelReservationByOrderId', supportedValues: ['on', 'off'] }),
  venueLocationSyncToggle: createRemoteFeatureFlag({ key: 'venuelocationsynctoggle', supportedValues: ['on', 'off'] }),
  travelCheckoutEnableCached: createRemoteFeatureFlag({ key: 'travelCheckoutEnableCached', supportedValues: ['on', 'off'] }),
  /** A/B experiment: Show checkout session countdown timer on checkout page */
  travelCheckoutSessionTimer: createRemoteFeatureFlag({
    key: 'travelCheckoutSessionTimer',
    supportedValues: ['control', 'treatment'],
  }),
  /** Enables AI recommendations note to show on tour step else show tags. See TRAV-1859 */
  aiRecommendationsNoteEnabled: createRemoteFeatureFlag({ key: 'aiRecommendationsNoteEnabled', supportedValues: ['on', 'off'] }),
  /** A/B test: Hide visibility toggle on accommodations page */
  accommodationsHideVisibilityToggle: createRemoteFeatureFlag({ key: 'accommodationsHideVisibilityToggle', supportedValues: ['control', 'treatment'] }),
  accommodationsVisibilityBanner: createRemoteFeatureFlag({ key: 'accommodationsvisibilitybanner', supportedValues: ['control', 'treatment'] }),
  accommodationsStayAreas: createRemoteFeatureFlag({ key: 'accommodationsStayAreas', supportedValues: ['control', 'treatment'] }),
  /** Rollout: replace GoogleMapEmbed iframe with StaticMap image in schedule/travel MapBlock components */
  guestStaticMapRollout: createRemoteFeatureFlag({ key: 'guestStaticMapRollout', supportedValues: ['on', 'off'] }),
  /** Experiment A: Promotes hotel deals with countdown subtitle in guest guide */
  guestGuideHotelDealsPromotionExperiment: createRemoteFeatureFlag({ key: 'guestGuideHotelDealsPromotionExperiment', supportedValues: ['control', 'treatment'] }),
  /** Experiment B: Shows prominent booking CTA card at top of guest guide */
  guestGuideBookingCtaExperiment: createRemoteFeatureFlag({ key: 'guestGuideBookingCtaExperiment', supportedValues: ['control', 'treatment'] }),
  /** Enables hotel suggest dialog with AI CTA in accommodations admin */
  hotelSuggestDialog: createRemoteFeatureFlag({ key: 'hotelSuggestDialog', supportedValues: ['control', 'treatment'] }),
  /** Enables section-level layout selector in accommodations admin */
  accommodationsLayoutSelector: createRemoteFeatureFlag({ key: 'accommodationsLayoutSelector', supportedValues: ['control', 'treatment'] }),
  /** Enables accommodations admin preview update (explore area, venue info, legend overlay) */
  accommodationsAdminPreviewUpdate: createRemoteFeatureFlag({ key: 'accommodationsAdminPreviewUpdate', supportedValues: ['control', 'treatment'] }),
  /** Compact 2-column card layout for hotel PDP on mobile — treatment shows compact cards with drawer detail view */
  hotelPDPCompactCards: createRemoteFeatureFlag({ key: 'hotelPDPCompactCards', supportedValues: ['control', 'treatment'] }),
  /** A/B experiment: Show low-availability badge ("Only N rooms left for your dates") on PDP offer cards */
  travelLowAvailabilityMessaging: createRemoteFeatureFlag({
    key: 'travelLowAvailabilityMessaging',
    supportedValues: ['control', 'treatment'],
  }),
  /** Enables the redesigned OfferSummary card UI (V2) on checkout and reservation status pages */
  accommodationsOfferSummaryV2: createRemoteFeatureFlag({
    key: 'accommodationsOfferSummaryV2',
    supportedValues: ['control', 'offer_summary_v2', 'offer_summary_v2_with_cancellation_policy', 'offer_summary_v2_with_refundable_upsell'],
  }),

  /*
   * Contact Collection Feature Flags
   */
  contactCollectionInternationalAddressValidationEnabled: createRemoteFeatureFlag('contactCollectionInternationalAddressValidationEnabled'),
  contactCollectionSmsAgreementVariant: createRemoteFeatureFlag({ key: 'contactCollectionSmsAgreementVariant', supportedValues: ['variant1', 'variant2'] }),
  enableContactCollectionMessage: createRemoteFeatureFlag({ key: 'enablecontactcollectionmessage', supportedValues: ['on', 'off'] }),
  contactCollectionDisablePhoneNumberValidationFor: createRemoteFeatureFlag('contactcollectiondisablephonenumbervalidationfor'),
  contactCollectionCsvUploadEnabled: createRemoteFeatureFlag('contactcollectioncsvuploadenabled'),
  shopSubCatHighlightsExperiment: createRemoteFeatureFlag({ key: 'shopSubCatHighlightsExperiment', supportedValues: ['control', 'treatment'] }),

  weddingShopFeatureEnabled: createRemoteFeatureFlag({ key: 'weddingshopfeatureenabled', supportedValues: ['on', 'off', 'variant2'] }),
  /**
   * Admin Dashboard
   */
  photoAlbumMultiPhotoUploadEnabledV2: createRemoteFeatureFlag({ key: 'photoalbummultiphotouploadv2', supportedValues: ['on', 'off'] }),
  albumSlideShowExperiment: createRemoteFeatureFlag({ key: 'albumSlideShowExperiment', supportedValues: ['control', 'treatment'] }),
  allCollectionPhotosEnabled: createRemoteFeatureFlag({ key: 'allcollectionphotosenabled', supportedValues: ['on', 'off'] }),
  photoUploadFromCollectionEnabled: createRemoteFeatureFlag({ key: 'photouploadfromcollection', supportedValues: ['on', 'off'] }),
  photoGalleryCustomBlockEnabled: createRemoteFeatureFlag({ key: 'photogallerycustomblockenabled', supportedValues: ['on', 'off'] }),
  pageWidthPhotoEnabled: createRemoteFeatureFlag({ key: 'pagewidthphoto', supportedValues: ['on', 'off'] }),
  websiteThingsToDoAnnouncement: createRemoteFeatureFlag({ key: 'websiteThingsToDoAnnouncement', supportedValues: ['on', 'off'] }),
  eventPhotoV2UrlMigration: createRemoteFeatureFlag({ key: 'eventphotov2urlmigration', supportedValues: ['on', 'off'] }),
  websitePhotoSortingEnabled: createRemoteFeatureFlag({ key: 'websitephotosortingenabled', supportedValues: ['on', 'off'] }),
  websitePhotoAssignToPageEnabled: createRemoteFeatureFlag('websitephotosassigntopageenabled'),

  /**
   * Guest site
   */
  hideJoyLogo: createRemoteFeatureFlag('hidejoylogo'),
  guestBrannanCoverPhotoV2Enabled: createRemoteFeatureFlag({ key: 'guestbrannancoverphotov2enabled', supportedValues: ['on', 'off'] }),
  websiteVideoBackgroundEnabled: createRemoteFeatureFlag({ key: 'websiteVideoBackgroundEnabled', supportedValues: ['on', 'off'] }),
  // TODO: if we are resolving hideGetTheAppPageExperiment flag, we need to cleanup some "Get the App" code for that please refer - https://github.com/joylifeinc/joy-web/pull/9648
  hideGetTheAppPageExperiment: createRemoteFeatureFlag({ key: 'hidegettheapppageexperiment', supportedValues: ['control', 'treatment'] }),
  websiteInterceptExternalHotelLinksV2: createRemoteFeatureFlag({ key: 'websiteinterceptexternalhotellinksv2', supportedValues: ['on', 'off'] }),
  websiteInterceptExternalHotelLinksAdmin: createRemoteFeatureFlag({ key: 'websiteinterceptexternalhotellinksadmin', supportedValues: ['on', 'off'] }),
  guestguideexperiment: createRemoteFeatureFlag({
    key: 'guestguideexperiment',
    supportedValues: ['control', 'treatment'],
    consentValueForTrue: 'treatment',
  }),
  showGuestGuide: createFeatureFlagConfig('showGuestGuide', true),
  accommodationsPriceAlerts: createRemoteFeatureFlag({ key: 'accommodationsPriceAlerts', supportedValues: ['control', 'treatment'] }),
  accommodationsPageCountdown: createRemoteFeatureFlag({ key: 'accommodationsPageCountdown', supportedValues: ['control', 'treatment'] }),
  guestSkipPagePhotoRendition: createRemoteFeatureFlag({ key: 'guestskippagephotorendition', supportedValues: ['on', 'off'] }),
  guestPageContentRedesign: createRemoteFeatureFlag({ key: 'guestPageContentRedesign', supportedValues: ['on', 'off'] }),
  websiteSchedulePageLayoutTypeSelectorEnabled: createRemoteFeatureFlag('websiteschedulepagelayouttypeselectorenabled'),
  guestBackgroundHeaderBouncingChevronEnabled: createRemoteFeatureFlag({ key: 'guestbackgroundheaderbouncingchevron', supportedValues: ['on', 'off'] }),
  guestMobileFooterNavEnabled: createRemoteFeatureFlag({ key: 'guestmobilefooternav', supportedValues: ['on', 'off'] }),
  guestResetLetterSpacingForFontPack: createRemoteFeatureFlag({ key: 'guestresetletterspacingforfontpack', supportedValues: ['on', 'off'] }),
  websiteSelfHostedGoogleFontsEnabled: createRemoteFeatureFlag({ key: 'websiteselfhostedgooglefontsenabled', supportedValues: ['on', 'off'] }),
  websiteInitialHeaderAnimationDisabled: createRemoteFeatureFlag({ key: 'websiteinitialheaderanimationdisabled', supportedValues: ['on', 'off'] }),

  /**
   * Webiste Design
   */
  joyWebAppBoundaryEnabled: createRemoteFeatureFlag({ key: 'joywebappboundaryenabled', supportedValues: ['on', 'off'] }),
  previewSiteWithThemeExperiment: createRemoteFeatureFlag({ key: 'marcomViewDemoSiteExperiment', supportedValues: ['control', 'treatment'] }),
  websiteTemplateOrdering: createRemoteFeatureFlag({ key: 'websitetemplateordering', supportedValues: ['on', 'off'] }),
  hotelFirstPartySearchEnabled: createRemoteFeatureFlag({ key: 'hotelfirstpartysearchenabled', supportedValues: ['control', 'treatment'] }),
  adminDashboardHoneymoonEnabled: createRemoteFeatureFlag({ key: 'adminDashboardHoneymoonEnabled', supportedValues: ['on', 'off'] }),
  accommodationsGuestHotelTileExperiment: createRemoteFeatureFlag({ key: 'accommodationsGuestHotelTileExperiment', supportedValues: ['control', 'treatment'] }),
  /** Experiment flag to test different versions of the accommodation visibility confirmation modal */
  accommodationVisibilityConfirmationModalExperiment: createRemoteFeatureFlag({
    key: 'accommodationvisibilityconfirmationmodalexperiment',
    supportedValues: ['0', '1', '2', '3'],
    defaultValue: '0',
  }),
  bookingCountExperiment: createRemoteFeatureFlag({ key: 'bookingCountExperiment', supportedValues: ['control', 'treatment'] }),
  travelGuestCurrencySwitch: createRemoteFeatureFlag({ key: 'travelGuestCurrencySwitch', supportedValues: ['on', 'off'] }),
  /** Controls which currency codes are available in the travel currency selector via payload */
  travelCurrencies: createRemoteFeatureFlag({ key: 'travelCurrencies', supportedValues: ['control', 'treatment'] }),
  /**
   * Create page - Native specs
   */
  createPageNativeSpecs: createRemoteFeatureFlag({ key: 'createPageNativeSpecs', supportedValues: ['control', 'treatment'] }),
  /**
   * Dashboard Travel Survey
   */
  dashboardTravelSurvey: createRemoteFeatureFlag({ key: 'dashboardTravelSurvey', supportedValues: ['on', 'off'] }),
  /**
   * Honeymoon lead gen Survey
   */
  honeymoonLeadGenSurvey: createRemoteFeatureFlag({ key: 'honeymoonLeadGenSurvey', supportedValues: ['on', 'off'] }),
  /**
   * Day-Of Coordinator Survey
   */
  dayOfLeadGenSurvey: createRemoteFeatureFlag({ key: 'dayOfLeadGenSurvey', supportedValues: ['on', 'off'] }),
  /**
   * Cancellation Reason Survey
   */
  cancellationReasonSurvey: createRemoteFeatureFlag({ key: 'cancelationreasonsurvey', supportedValues: ['on', 'off'] }),

  /**
   * CUG Not Verified Page
   */
  cugAccessCodes: createRemoteFeatureFlag({ key: 'cugAccessCodes', supportedValues: ['on', 'off'] }),
  /**
   * General Event
   */
  enableCreateGeneralEventRoutes: createRemoteFeatureFlag({ key: 'enablecreategeneraleventroutes', supportedValues: ['on', 'off'] }),
  generalEventSettingsUsersV2EnableAddCollaboratorsButton: createRemoteFeatureFlag({
    key: 'generaleventsettingsusersv2enableaddcollaboratorsbutton',
    supportedValues: ['on', 'off'],
  }),

  /**
   * Wedding Event Creation
   */
  createWeddingDefaultThemeExperiment: createRemoteFeatureFlag({ key: 'createWeddingDefaultThemeExperiment', supportedValues: ['control', 'treatment1', 'treatment2'] }),
  createWeddingHeaderLayoutExperiment: createRemoteFeatureFlag({ key: 'createWeddingHeaderLayoutExperiment', supportedValues: ['on', 'off'] }),
  /**
   * i18n
   */
  joyWebTranslationsEnabled: createRemoteFeatureFlag({ key: 'joywebtranslations', supportedValues: ['on', 'off'] }),
  /*
   * General event and joy pro feature flags
   */
  generalEventCategoryConfig: createRemoteFeatureFlag({ key: 'generaleventcategoryconfig', supportedValues: ['on', 'off'] }),
  /**
   * Sanitize string
   */
  nuiteeQueryStringSanitization: createRemoteFeatureFlag({ key: 'nuiteeQueryStringSanitization', supportedValues: ['on', 'off'] }),
  /*
   * User consent feature flags
   */
  dayOfLeadGenSurveyCompleted: createRemoteFeatureFlag({ key: 'dayOfLeadGenSurveyCompleted', supportedValues: ['on', 'off'] }),
  enablePostRsvpHotelBookReminder: createRemoteFeatureFlag({ key: 'enablePostRsvpHotelBookReminder', supportedValues: ['on', 'off'] }),
  expandedMapAnnouncementSeen: createRemoteFeatureFlag({ key: 'expandedMapAnnouncementSeen', supportedValues: ['on', 'off'] }),
  honeymoonAnnouncementSeen: createRemoteFeatureFlag({ key: 'honeymoonAnnouncementSeen', supportedValues: ['on', 'off'] }),
  honeymoonLeadGenSurveyCompleted: createRemoteFeatureFlag({ key: 'honeymoonLeadGenSurveyCompleted', supportedValues: ['on', 'off'] }),
  isAutoPopulationDone: createRemoteFeatureFlag({ key: 'isAutoPopulationDone', supportedValues: ['on', 'off'] }),
  scheduleOptOutAddToCalendar: createRemoteFeatureFlag({ key: 'scheduleOptOutAddToCalendar', supportedValues: ['on', 'off'] }),
  scheduleOptOutWhereToStayLink: createRemoteFeatureFlag({ key: 'scheduleOptOutWhereToStayLink', supportedValues: ['on', 'off'] }),
  newScheduleEditorForOldEventsEnabled: createRemoteFeatureFlag({ key: 'newScheduleEditorForOldEventsEnabled', supportedValues: ['on', 'off'] }),
  showAiRecommendationsFeedbackDialog: createRemoteFeatureFlag({ key: 'showAiRecommendationsFeedbackDialog', supportedValues: ['on', 'off'] }),
  showAutoPopulationCompletedDialog: createRemoteFeatureFlag({ key: 'showAutoPopulationCompletedDialog', supportedValues: ['on', 'off'] }),
  showGuestsNearbyHotels: createRemoteFeatureFlag({ key: 'showGuestsNearbyHotels', supportedValues: ['on', 'off'] }),
  // Default on so guests see booking links unless couples opt out.
  showBookingLinksOnRegistryPurchaseConfirmation: createRemoteFeatureFlag({
    key: 'showBookingLinksOnRegistryPurchaseConfirmation',
    supportedValues: ['on', 'off'],
    defaultValue: 'on',
  }),
  showExploreMoreStaysOnGuestSite: createRemoteFeatureFlag({ key: 'showExploreMoreStaysOnGuestSite', supportedValues: ['on', 'off'], defaultValue: 'on' }),
  showMothersDayDashboardModal: createRemoteFeatureFlag({ key: 'showMothersDayDashboardModal', supportedValues: ['on', 'off'] }),
  showStayAreasOnGuestSite: createRemoteFeatureFlag({ key: 'showStayAreasOnGuestSite', supportedValues: ['on', 'off'], defaultValue: 'on' }),
  showValentinesDayDialog: createRemoteFeatureFlag({ key: 'showValentinesDayDialog', supportedValues: ['on', 'off'] }),
  thingsToDoAnnouncementSeen: createRemoteFeatureFlag({ key: 'thingsToDoAnnouncementSeen', supportedValues: ['on', 'off'] }),
  websiteAllowHotelLinkIntercept: createRemoteFeatureFlag({ key: 'websiteAllowHotelLinkIntercept', supportedValues: ['on', 'off'], defaultValue: 'on' }),
  websiteOptOutTripProfit: createRemoteFeatureFlag({ key: 'websiteOptOutTripProfit', supportedValues: ['on', 'off'] }),
  /*
   * Admin RSVP feature flags
   */
  adminRSVPV2Enabled: createRemoteFeatureFlag({ key: 'adminRSVPV2Enabled', supportedValues: ['on', 'off'] }),
  /*
   * Event Session Optimization
   */
  skipEventSessionForReadOnlyQueries: createRemoteFeatureFlag({ key: 'skipEventSessionForReadOnlyQueries', supportedValues: ['on', 'off'] }),
  /*
   * Guided Moments
   */
  joyGuidedMoments: createRemoteFeatureFlag({ key: 'joyGuidedMoments', supportedValues: ['on', 'off'] }),
  /*
   * Joy Pro
   */
  enableRegistrationApproval: createRemoteFeatureFlag({ key: 'enableregistrationapproval', supportedValues: ['on', 'off'] }),
  carbonTicketingEnabled: createRemoteFeatureFlag({ key: 'carbonticketingenabled', supportedValues: ['on', 'off'] }),
  carbonEnableTicketPayments: createRemoteFeatureFlag({ key: 'carbonEnableTicketPayments', supportedValues: ['on', 'off'] }),
  joyProExposeCarbon: createRemoteFeatureFlag({ key: 'joyproexposecarbon', supportedValues: ['on', 'off'] }),
  joyProRegistrationV2Enabled: createRemoteFeatureFlag({ key: 'joyproregistrationv2enabled', supportedValues: ['on', 'off'] }),
  joyProRegistrationV2EnableTagging: createRemoteFeatureFlag({ key: 'joyproregistrationv2enabletagging', supportedValues: ['on', 'off'] }),
  joyProGuestIdentificationDialog: createRemoteFeatureFlag({ key: 'joyproguestidentificationdialog', supportedValues: ['on', 'off'] }),
  /*
   * IntlTelInput new version
   */
  intlTelInputEnabled: createRemoteFeatureFlag({ key: 'useIntlTelInputEnabled', supportedValues: ['on', 'off'] }),
  /**
   * Website Glass Effect
   */
  websiteGlassEffect: createRemoteFeatureFlag({ key: 'websiteGlassEffect', supportedValues: ['on', 'off'] }),
  /**
   * Language Settings
   */
  languageSettingEnabled: createRemoteFeatureFlag({ key: 'languagesettingenabled', supportedValues: ['on', 'off'] }),
  /**
   * Wedding Party List Circle Avatars
   */
  weddingPartyListCircleAvatars: createRemoteFeatureFlag({ key: 'weddingPartyListCircleAvatars', supportedValues: ['on', 'off'] }),
  /**
   * Guest List V2
   */
  guestListV2Enabled: createRemoteFeatureFlag({ key: 'guestListV2Enabled', supportedValues: ['on', 'off'] }),
  useDirectGuestListV2: createRemoteFeatureFlag({ key: 'useDirectGuestListV2', supportedValues: ['on', 'off'] }),

  /**
   * Custom Page ItemList Integration
   * Enables the new ItemList-based component list in custom page editor.
   * @see doc/plans/item-list-integration/implementation-plan.md
   */
  customPageItemListEnabled: createRemoteFeatureFlag({ key: 'customPageItemListEnabled', supportedValues: ['on', 'off'] }),

  /**
   * Custom Components ItemList Unification
   * Gates the migration of FAQ and VIP default-view editors from bespoke
   * SortableList to the shared Joykit ItemList pattern.
   */
  customComponentItemListUnified: createRemoteFeatureFlag({ key: 'customComponentItemListUnified', supportedValues: ['on', 'off'] }),
  /**
   * Admin Command Palette (Cmd+K)
   * Gates the command palette on the admin dashboard.
   */
  adminCommandPaletteEnabled: createRemoteFeatureFlag({ key: 'adminCommandPaletteEnabled', supportedValues: ['on', 'off'], defaultValue: 'off' }),

  /**
   * Group Messaging — SMS Channel
   * Gates whether SMS is available as a delivery channel (geo-targeting via Amplitude).
   * Separate from the `useGroupMessaging` event flag which is the feature kill switch.
   */
  smsChannelEnabled: createRemoteFeatureFlag({ key: 'smschannelenabled', supportedValues: ['on', 'off'] }),

  rsvpSettingsInJoySettings: createRemoteFeatureFlag('rsvpsettingsinjoysettings'),

  /**
   * Registration Matching Option
   * Enables the option to match the registration form to the design of the website.
   */
  registrationFormMatchingWebsite: createBooleanFeatureFlag('registrationFormMatchingWebsite'),

  /**
   * Gates the honeymoon cash fund success modal that shows after creating a cash fund.
   * When enabled, shows a honeymoon-themed success screen with destination browsing CTA.
   */
  enableHoneymoonCashFundSuccessModal: createRemoteFeatureFlag('enablehoneymooncashfundsuccessmodal'),
} as const;

export type FeatureFlags = typeof FEATURE_FLAG_VALUES;
